import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import Select from 'react-select-legacy';
import FilterCheckbox from 'components/filters/FilterCheckbox';
import { isEmpty } from 'lodash';

const BulkMessage = ({ message, filters, onChange, onCardChange, onProgramContentChange }) => {
  const { body, bodyEs, pushTitle, pushTitleEs, pushText, pushTextEs, programContentEntryIds, cardIds, sendInaccessibleAttachedContent } = message;
  return (
    <div className='column small-12'>
      <label>
        English
        <TextareaAutosize name='body' value={body} onChange={onChange} />
      </label>
      <label>
        Spanish
        <TextareaAutosize name='bodyEs' value={bodyEs} onChange={onChange} />
      </label>
      <div className='row u-margin-bottom--base'>
        <div className='column small-12 medium-6'>
          <label>
            Push Title
            <input name='pushTitle' type='text' value={pushTitle} onChange={onChange} />
          </label>
        </div>
        <div className='column small-12 medium-6'>
          <label>
            Push Title (Spanish)
            <input name='pushTitleEs' type='text' value={pushTitleEs} onChange={onChange} />
          </label>
        </div>
        <div className='column small-12 medium-6'>
          <label>
            Push Text
            <input name='pushText' type='text' value={pushText} onChange={onChange} />
          </label>
        </div>
        <div className='column small-12 medium-6'>
          <label>
            Push Text (Spanish)
            <input name='pushTextEs' type='text' value={pushTextEs} onChange={onChange} />
          </label>
        </div>
      </div>
      <div className='row u-margin-bottom--base'>
        <div className='column small-12 medium-6'>
          <Select
            name='sp-cards-select'
            className={'o-select o-select--optgroup'}
            disabled={!isEmpty(programContentEntryIds)}
            multi={true}
            value={cardIds || []}
            onChange={onCardChange}
            options={filters.cards}
            placeholder='Cards'/>
        </div>
        <div className='column small-12 medium-6'>
          <Select
            name='sp-pc-select'
            className={'o-select o-select--optgroup'}
            disabled={!isEmpty(cardIds)}
            multi={true}
            value={programContentEntryIds || []}
            onChange={onProgramContentChange}
            options={filters.pcs}
            placeholder='Tips'/>
        </div>
      </div>
      <div className='row u-margin-bottom--base'>
        <div className='column small-12 medium-12'>
          <FilterCheckbox label='Send regardless whether that content is turned on in Sparkler for the child' value={sendInaccessibleAttachedContent || false} onChange={(value) => {
            onChange({
              target: {
                name: "sendInaccessibleAttachedContent",
                value: value,
              }
            });
          }}/>
        </div>
      </div>
    </div>
  );
}

BulkMessage.propTypes = {
  filters: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onCardChange: PropTypes.func.isRequired,
  onProgramContentChange: PropTypes.func.isRequired,
}

export default BulkMessage;
